import { render } from "./examine.vue?vue&type=template&id=204159d7&scoped=true"
import script from "./examine.vue?vue&type=script&lang=js"
export * from "./examine.vue?vue&type=script&lang=js"

import "./examine.vue?vue&type=style&index=0&id=204159d7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204159d7"]])

export default __exports__